import { mutationUpdate, type UpdateHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { type PasswordChangeInput, type PasswordChangeSuccess, toResponseError } from '@terros/common'

export function useChangePassword(): UpdateHookResponse<PasswordChangeInput, PasswordChangeSuccess> {
  const mutation = useTantalimMutation<PasswordChangeInput, PasswordChangeSuccess>({
    url: '/user/password/change',
  })

  async function update(): Promise<PasswordChangeSuccess> {
    try {
      return await mutation.mutateAsync({})
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, update)
}
